<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="supplies_list"
            :url="url"
            :columns="userListColumn"
            :span-method="objectSpanMethod"
            :tableHeight="tableHeight"
            :buttons="[]"
            disableOrderDefaultSort
            :showSequence="false"
            :enableFilter="{ enabled: false }"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :fuzzySearch="false"
        >
            <slot slot="filter">
                <!-- <el-col :span="3">
                    <item-input type="select" style="height: 32px; line-height: 32px" v-model="dateType" :options="dateTypeOption" placeholder="请选择时间类型"></item-input>
                </el-col> -->
                <el-col :span="7">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="multiselect" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="string" v-model="supplie_name" placeholder="请输入耗材名称"></item-input>
                </el-col>
                <el-col :span="7">
                    <!-- <item-input type="radio" v-model="searchType" :options="searchTypeOption" style="padding-left: 20px;"></item-input> -->
                    <el-radio-group v-model="searchType" size="mini" style="padding-left: 20px;text-align: left">
                        <el-radio-button v-show="isActive(1)" label="1">患者</el-radio-button>
                        <el-radio-button v-show="isActive(2)" label="2">术间</el-radio-button>
                        <el-radio-button v-show="isActive(3)" label="3">耗材</el-radio-button>
                    </el-radio-group>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="refreshList()">查询<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`export`)" @click="exportSupplies">导出</el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`print`)" @click="printSupplies">打印</el-button>
                <el-popover placement="bottom" :open-delay="600">
                    <el-button size="mini" plain slot="reference">
                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                        <span class="hidden-md-and-down">&nbsp;列配置</span>
                    </el-button>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: 100px;">
                        <div class="config-column">
                            <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                        </div>
                    </el-scrollbar>
                    <el-divider></el-divider>
                    <div style="text-align: right">
                        <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                    </div>
                </el-popover>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
// import { forEach } from 'lodash'
import Sortable from 'sortablejs'
import { mapGetters } from 'vuex'
export default {
    name: `SupplyStatistics`,
    props: {},
    data() {
        return {
            title: `耗材统计`,
            url: {
                baseURL: `/api/AcisSystem/SupplyStatistics`,
                get: paras => {
                    return new Promise(resolve => {
                        this.loadSupplyStatistics().then(data => {
                            resolve(data)
                        })
                    })
                }
            },
            o_dic_operating_ward_id: undefined,
            dateType: 1,
            searchType: 1,
            applytype: this.$route.query.applytype || 1,
            issetoperatingward: false,
            dic_room_id: undefined,
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            searchTypeConfig: this.$root.SupplyStatisticsConfig && this.$root.SupplyStatisticsConfig.split(`|`).map(d => parseInt(d)) || [1, 2, 3],
            dataList: [],
            user_config_columns: [],
            configColumns: [],
            supplie_name: ``
        }
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `permissions`, `ward_auth`, `currentUser`, `sys_enums`, `section_auth`, `operation_ward_auth`, `recovery_ward_auth`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        operationRoom() {
            let r = this.operation_ward_auth && this.operation_ward_auth.find(i => i.value == this.dic_operating_ward_id)
            return r && r.operation_room.length > 0 ? _.orderBy(r.operation_room, `display_order`) : []
        },
        searchTypeOption() {
            return [
                { label: `明细`, value: 1 },
                { label: `分组`, value: 2 }
            ]
        },
        isActive() {
            let that = this
            return function(searchType) {
                return _.includes(that.searchTypeConfig, searchType)
            }
        },
        dateTypeOption() {
            return [
                { label: `申领时间`, value: 1 }
                // ,{ label: `使用时间`, value: 2 }
            ]
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable) ||
                    c.prop == `dic_operatingroom_name` || c.prop == `patient_name` || c.prop == `anes_doctor` || c.prop == `use_time`
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        },
        columnList() {
            let arr = []
            arr = [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                // {
                //     type: `string`,
                //     prop: `visit_no`,
                //     label: this.T(`apply_surgery.visit_no`),
                //     isListable: this.searchType == 1,
                //     width: `150`
                // },
                {
                    type: `string`,
                    prop: `dic_operatingroom_name`,
                    label: `手术间`,
                    width: `120`,
                    isListable: this.searchType != 3
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    width: `130`,
                    isListable: this.searchType == 1,
                    isExpand: false
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: this.searchType == 1 ? `麻醉医生` : `申请医生`,
                    width: `80`,
                    isListable: this.searchType != 3
                },
                {
                    type: `datetime`,
                    prop: `use_time`,
                    label: `使用时间`,
                    width: `120`,
                    isListable: this.searchType == 1
                },
                {
                    type: `date`,
                    prop: `use_time`,
                    label: `申领日期`,
                    width: `100`,
                    isListable: this.searchType == 2
                },
                {
                    type: `string`,
                    prop: `supplie_name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false
                },
                {
                    type: `string`,
                    prop: `supplie_spec`,
                    label: `规格`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `apply_quantity`,
                    label: `申领数量`,
                    width: this.searchType == 2 ? `80` : `100`,
                    isListable: this.searchType != 1,
                    searchable: false
                },
                {
                    type: `number`,
                    prop: `supplement_quantity`,
                    label: `补充数量`,
                    width: this.searchType == 2 ? `80` : `100`,
                    isListable: this.searchType != 1 && this.applytype == 1,
                    searchable: false
                },
                {
                    type: `number`,
                    prop: `prepare_quantity`,
                    label: `发放数量`,
                    width: this.searchType == 2 ? `80` : `100`,
                    isListable: this.searchType != 1,
                    searchable: false
                },
                {
                    type: `number`,
                    prop: `add_quantity`,
                    label: `转入数量`,
                    width: `80`,
                    isListable: this.searchType == 2,
                    searchable: false
                },
                {
                    type: `number`,
                    prop: `reduce_quantity`,
                    label: `转出数量`,
                    width: `80`,
                    isListable: this.searchType == 2,
                    searchable: false
                },
                {
                    type: `number`,
                    prop: `use_quantity`,
                    label: `使用数量`,
                    width: this.searchType == 1 ? `200` : (this.searchType == 2 ? `80` : `100`),
                    isListable: true,
                    searchable: false
                },
                {
                    type: `number`,
                    prop: `damaged_quantity`,
                    label: `损耗数量`,
                    width: this.searchType == 1 ? `200` : (this.searchType == 2 ? `80` : `100`),
                    isListable: true,
                    searchable: false
                },
                {
                    type: `number`,
                    prop: `back_quantity`,
                    label: `归还数量`,
                    width: this.searchType == 2 ? `80` : `100`,
                    isListable: this.searchType != 1,
                    searchable: false
                }
            ]
            return arr
        }
    },
    created() {
        // 加载配置列
        this.loadConfigColumns()
        this.configColumnDrop()
    },
    methods: {
        isHavePermissions(permiskey) {
            return this.permissions && ((this.applytype == 1 && this.permissions.findIndex(item => item.permission === `mzSupplyApply:${permiskey}`) != -1) ||
                (this.applytype == 2 && this.permissions.findIndex(item => item.permission === `hlSupplyApply:${permiskey}`) != -1 &&
                (this.permissions.findIndex(item => item.permission === `hlSupplyApply:zq`) != -1 ||
                  this.permissions.findIndex(item => item.permission === `hlSupplyApply:jz`) != -1)
                ))
        },
        logExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        loadConfigColumns() {
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=api_supplies/supply_statistics${this.searchType}`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs
                    .map(c => {
                        return { value: c.prop, label: c.label, isListable: c.isListable }
                    })
                    .filter(d => {
                        return d.label != `unique` && d.isListable
                    })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
            })
        },
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: `api_supplies/supply_statistics${this.searchType}`
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        exportSupplies() {
            let that = this
            // eslint-disable-next-line camelcase
            let dic_operating_ward_ids = []
            if (that.dic_operating_ward_id > 0) {
                dic_operating_ward_ids.push(that.dic_operating_ward_id)
            } else {
                // eslint-disable-next-line camelcase
                dic_operating_ward_ids = []
                _.forEach(that.operation_ward_auth, b => {
                    dic_operating_ward_ids.push(b.value)
                })
            }
            let obj = {
                dateType: 1,
                applytype: this.applytype,
                begintime: that.rdate[0],
                endtime: that
                    .$moment(this.rdate[1])
                    .add(1, `days`)
                    .format(`YYYY/MM/DD`),
                dic_operating_ward_id: dic_operating_ward_ids,
                dic_room_id: that.dic_room_id,
                searchType: that.searchType,
                supplie_name: that.supplie_name
            }
            let req = that.myaxios.post(`/api/AcisSystem/SupplyStatistics/GetSupplieTJForExport`, obj)
            req.then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                that.myaxios.export_excel(data, `耗材统计.xls`)
            }).catch(e => {
                that.$message.error(`导出数据出错`)
            })
        },
        printSupplies() {
            let that = this
            let doccode = this.applytype == 1 ? `STJ001` : `STJ002`
            let wardids = []
            if (that.dic_operating_ward_id > 0) {
                wardids.push(that.dic_operating_ward_id)
            } else {
                // eslint-disable-next-line camelcase
                wardids = []
                _.forEach(that.operation_ward_auth, b => {
                    wardids.push(b.value)
                })
            }
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[`${doccode}`],
                            id1: that.applytype,
                            objId: `${wardids && wardids.join(`,`)}|${that.dic_room_id && that.dic_room_id.join(`,`)}|${that.supplie_name}`,
                            from: this.$moment(that.rdate[0]).format(`YYYYMMDDHHmm`),
                            to: this.$moment(this.rdate[1])
                                .add(1, `days`)
                                .format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        refreshList() {
            this.$refs[`supplies_list`].ReloadListData()
        },
        loadSupplyStatistics() {
            let that = this
            // eslint-disable-next-line camelcase
            let dic_operating_ward_ids = []
            if (that.dic_operating_ward_id > 0) {
                dic_operating_ward_ids.push(that.dic_operating_ward_id)
            } else {
                // eslint-disable-next-line camelcase
                dic_operating_ward_ids = []
                _.forEach(that.operation_ward_auth, b => {
                    dic_operating_ward_ids.push(b.value)
                })
            }
            console.log(dic_operating_ward_ids)
            return new Promise((resolve, reject) => {
                let obj = {
                    dateType: 1,
                    applytype: this.applytype,
                    begintime: that.rdate[0],
                    endtime: that
                        .$moment(this.rdate[1])
                        .add(1, `days`)
                        .format(`YYYY/MM/DD`),
                    dic_operating_ward_id: dic_operating_ward_ids,
                    dic_room_id: that.dic_room_id,
                    searchType: that.searchType,
                    supplie_name: that.supplie_name
                }
                let req = this.myaxios.post(`/api/AcisSystem/SupplyStatistics/Get`, obj)
                req.then(res => {
                    _.map(res, (d, index) => {
                        if (d.prepare_quantity > 0) {
                            d.back_quantity = d.prepare_quantity - d.use_quantity - d.damaged_quantity + ((d.add_quantity || 0) - (d.reduce_quantity || 0))
                        } else {
                            d.back_quantity = (d.apply_quantity + d.supplement_quantity) - d.use_quantity - d.damaged_quantity + ((d.add_quantity || 0) - (d.reduce_quantity || 0))
                        }
                    })
                    that.dataList = []
                    let groupId = _.groupBy(res, `patient_name`)
                    _.forEach(groupId, (group, index) => {
                        _.forEach(group, (item, cindex) => {
                            that.dataList.push({
                                ...item,
                                index: cindex,
                                length: group.length
                            })
                        })
                    })
                    console.log(`that.dataList`, that.dataList)
                    resolve(that.dataList)
                }).catch(e => reject(e))
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex < 3 && this.searchType != 3) {
                if (row.index == 0 && row.length > 0) {
                    return [row.length, 1]
                } else if (row.index == 0 && row.length == 2) {
                    return [1, 1]
                } else {
                    return [0, 0]
                }
            }
        },
        loadSuppliesCategory() {
            let req = this.myaxios.get(`/api/AcisSystem/SuppliesCategory/Get`)
            req.then(data => {
                this.suppliesCategory = _.map(data, d => {
                    return {
                        label: d.name,
                        value: d.id,
                        disabled: d.is_deleted
                    }
                })
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.applytype = newUrl.query.applytype
            // 加载配置列
            this.loadConfigColumns()
            this.configColumnDrop()
            this.refreshList()
        },
        searchType: function() {
            // 加载配置列
            this.loadConfigColumns()
            this.configColumnDrop()
            this.refreshList()
        }
    }
}
</script>
<style lang="less" scoped>
/deep/ .sumrow{
    font-weight: 800 !important;
}
/deep/ .cell{
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Supplies/SupplyStatistics.vue